import http from '../../utils/fetch';

let baseUrl = '/api/swyl/v1/productionforecast/bscProductionForecast';
export default {
    baseurl: baseUrl,
    /**
     * 下载模板地址
     */
    downExcelTempUrl: baseUrl + '/downloadProductionForecastExcelTemp',
    downExcelUrl: baseUrl + '/downloadProductionForecastExcel',
    /**
     * 分页查询市场预测集合
     * @param query 查询条件
     * @returns {AxiosPromise}
     */
    selectPage(query) {
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            // params: {pageSize:query.pageSize,pageNo:query.pageNo},
            params: query
        });
    },
    /**
     * 根据传入日期查询T+3周到T+13周列信息
     * @param query
     * @returns {AxiosPromise}
     */
    getCurTAfterWeeks(query) {
        return http({
            url: this.baseurl + '/getCurTAfterWeeks',
            method: 'post',
            params: query
        });
    },
    /**
     * 根据主键ID批量删除
     * @param ids
     * @returns {AxiosPromise}
     */
    deleteBatchByIds(ids){
        return http({
            url: this.baseurl + '/deleteBatchWeekDayYieldById',
            method: 'post',
            data: ids
        });
    },
    //批量导出
    downloadBatchExcel(query) {
        return http({
            url: '/api/swyl/v1/productionforecast/bscProductionForecast/downloadProductionForecastExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },
};
